import { baseQuery } from '../baseQuery';

import env from 'env';

export type BedrockApiResponse = {
  answer: string;
  session_id?: string | null;
  log_id: string;
  next_action: {
    type?: string;
    payload?: {
      title?: string;
      phone?: string;
      customerID?: string;
      jobID?: string;
      url?: string;
      msg?: string;
    };
  };
  citations?: Array<{

      body?: { text?: string };
      title?: string;
      url?: string;
      category?: string;


  }>;
  error?: string;
};


export type BedrockApiRateResponse = {
  answer: string;
  error?: string;
};

export type PostKnowledgebasePayload = {
  query: string;
  session_id: string | null;
  customer_ID?: number | null;
  suggestion_log_id?: number | null;
  category?: string;
  purpose?: string;
  show_citations?: boolean;
};

export type PostRateKnowledgebasePayload = {
  log_id: string;
  is_helpful: boolean;
  comment?: string;
};

export const postKnowledgebase = async (payload: PostKnowledgebasePayload): Promise<BedrockApiResponse> => {
  return await baseQuery('knowledgebase', {
    type: 'POST',
    body: payload,
    api: env.AI_API_SERVER, // add api server
  });
};

export const rateKnowledgebase = async (payload: PostRateKnowledgebasePayload): Promise<BedrockApiRateResponse> => {
  return await baseQuery('rate', {
    type: 'POST',
    body: payload,
    api: env.AI_API_SERVER, // add api server
  });
};

